goog.module('yext.apps.common.SuccessToast');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');

/**
 * @constructor
 */
const SuccessToast = function() {
  this.$ctxt = $('.js-success-toast');
  this.$toggleSteps = this.$ctxt.find('.js-toast-toggle-more');
  this.isExpanded = false;
};

SuccessToast.prototype.init = function() {
  this.bindToggleSteps();
};

SuccessToast.prototype.bindToggleSteps = function() {
  var toast = this;
  this.$toggleSteps.on('click', function() {
    toast.isExpanded = !toast.isExpanded;
    toast.$ctxt.find('.js-toast-install-steps').slideToggle(300);
    var text = '';
    if (toast.isExpanded) {
      text = yext.msg('Hide');
    } else {
      text = yext.msg('Show More');
    }
    toast.$toggleSteps.text(text);
  });
};

exports = SuccessToast;
